import {
  BatchAction,
  WeighedMaterialType,
} from '../../constants/MaterialModels';
import { ScaleTypes } from '../discharge-store';
import { toNumber } from '../../utils/numbers';
import logger from '../../utils/logger';
import { DeviceStatus } from '../../constants/DeviceStatus';

export const checkIfDischargeStartPercentForPumpsReady = (rootStore, data) => {
  if (!data?.pumps) {
    return;
  }

  const { batchStore } = rootStore;

  Object.keys(data.pumps).forEach(pumpId => {
    const pumpData = data.pumps[pumpId];
    isBatchStartPercentCorrect(rootStore, data, pumpData, (action) => {
      const ds = batchStore.getDeviceStatus(pumpData.pump.id);
      if (!pumpData.isDischarged && ds.status !== DeviceStatus.FEED) {
        batchStore.onBatchAction(data, action);
      }
    });
    isDischargeStartPercentCorrect(rootStore, data, pumpData, (action) => {
      const ds = batchStore.getDeviceStatus(pumpData.pump.id);
      if (!pumpData.isDischarged && ds.status !== DeviceStatus.DISCHARGING) {
        batchStore.onBatchAction(data, action);
      }
    });
  });
};

export const isBatchStartPercentCorrect = (rootStore, data, pumpData, onCorrect = () => {}) => {
  const { materialDetails } = pumpData;
  const action = materialDetails.batchStart;
  const actionPercent = materialDetails.batchStartPercent || 0;

  if (checkIsPercentCorrect(rootStore, data, pumpData, action, actionPercent)) {
    onCorrect(action);
    return true;
  }

  return false;

};

export const isDischargeStartPercentCorrect = (rootStore, data, pumpData, onCorrect = () => {}) => {
  const { materialDetails } = pumpData;
  const action = materialDetails.dischargeStart;
  const actionPercent = materialDetails.dischargeStartPercent || 0;

  if (checkIsPercentCorrect(rootStore, data, pumpData, action, actionPercent) && actionPercent > 0) {
    onCorrect(action);
    return true;
  }

  return false;
};

const checkIsPercentCorrect = (rootStore, data, pumpData, action, actionPercent) => {
  if (!data?.sequence?.discharges || !pumpData || !data?.scales) {
    return false;
  }

  const { batchStore, dischargeStore } = rootStore;
  const { pump } = pumpData;
  let isCorrect = false;

  if (action === BatchAction.FineAggStart && data.batchActionFired.includes(action)) {
    Object.entries(data.scales).forEach(([_, scales]) => {
      scales.forEach(({ scale, material, materialDetails, bin }) => {

        if (materialDetails.type === WeighedMaterialType.FineAggregate) {
          let ds;

          if (scale.decumulative) {
            ds = batchStore.getDeviceStatus(`${scale.id}-${material.code}`);
          } else {
            ds = batchStore.getDeviceStatus(bin?.id);
          }

          const target = ds.target;
          const weight = ds.weight;
          const isPercentCorrect = weight >= toNumber(target * (actionPercent / 100));
          const progress = weight > 0 ? toNumber((weight / target) * 100) : 0;

          logger.debug('is percent ok, pump ready?', pump.description, isPercentCorrect,
            action, progress, actionPercent, target, weight, material.code, bin?.description || scale.description);

          if (isPercentCorrect) {
            isCorrect = true;
          }
        }
      });
    });

  } else if (batchStore.discharging) {
    data.sequence?.discharges.forEach(v => {
      const scaleType = dischargeStore.getTypeForScale(v.scaleId);
      const p = batchStore.getPrimaryCumulative(v, data);
      const isPercentCorrect = p.target - p.weight >= p.target * (actionPercent / 100);
      const progress = p.weight > 0 ? toNumber((((p.target - p.weight) / p.target) * 100)) : 100;
      logger.debug('percent ok?, pump ready', pump.id, action, scaleType,
        `${actionPercent}% ${progress}%`, p.target * (actionPercent / 100), p.target - p.weight);

      if (isPercentCorrect
        && (
          (scaleType === ScaleTypes.AGG && action === BatchAction.ScaleAggDischargeStart)
          ||
          (scaleType === ScaleTypes.CEM && action === BatchAction.ScaleCemDischargeStart)
          ||
          (scaleType === ScaleTypes.WATER && action === BatchAction.ScaleWaterDischargeStart)
        )
      ) {
        isCorrect = true;
      }
    });
  } else if (data.finalScales && Object.keys(data.finalScales).length === data.finalScalesDischarged.length) {
    isCorrect = true;
  }

  return isCorrect;
};
